'use strict';exports.__esModule = true;exports.clearAddress = exports.clearForeignSearchData = exports.saveSearchedForeignAddress = exports.countForeignProperties = exports.searchForeignProperties = undefined;var _axios = require('axios');var _axios2 = _interopRequireDefault(_axios);
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);
var _reduxAct = require('redux-act');
var _reduxLoop = require('redux-loop');
var _formatApiError = require('../../helpers/formatApiError');var _formatApiError2 = _interopRequireDefault(_formatApiError);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var

promise = _reduxLoop.Effects.promise;

var saveSearchedForeignAddress = (0, _reduxAct.createAction)('/SAVE_SEARCHED_FOREIGN_ADDRESS');

var searchForeignProperties = (0, _reduxAct.createAction)('/SEARCH_FOREIGN_PROPERTIES');
var searchForeignPropertiesSuccess = (0, _reduxAct.createAction)('/SEARCH_FOREIGN_PROPERTIES_SUCCESS');
var searchForeignPropertiesFail = (0, _reduxAct.createAction)('/SEARCH_FOREIGN_PROPERTIES_FAIL');

var countForeignProperties = (0, _reduxAct.createAction)('/COUNT_FOREIGN_PROPERTIES');
var countForeignPropertiesSuccess = (0, _reduxAct.createAction)('/COUNT_FOREIGN_PROPERTIES_SUCCESS');
var countForeignPropertiesFail = (0, _reduxAct.createAction)('/COUNT_FOREIGN_PROPERTIES_FAIL');

var clearForeignSearchData = (0, _reduxAct.createAction)('/CLEAR_FOREIGN_SEARCH_DATA');

var clearAddress = (0, _reduxAct.createAction)('/CLEAR_ADDRESS');

var initialState = {
  loaded: false,
  loading: false,
  data: [],
  query: {},
  count: 0,
  searchedAddress: null,
  error: null };


var fetchLoad = function fetchLoad(_ref) {var _ref$requestType = _ref.requestType,requestType = _ref$requestType === undefined ? 'properties' : _ref$requestType,_ref$params = _ref.params,params = _ref$params === undefined ? {} : _ref$params;return _axios2.default.get('/' + requestType + '/foreign_search', {
    params: params }).

  then(searchForeignPropertiesSuccess, searchForeignPropertiesFail);};

var fetchCount = function fetchCount(_ref2) {var _ref2$requestType = _ref2.requestType,requestType = _ref2$requestType === undefined ? 'properties' : _ref2$requestType,_ref2$params = _ref2.params,params = _ref2$params === undefined ? {} : _ref2$params;return _axios2.default.get('/' + requestType + '/foreign_count', {
    params: params }).

  then(countForeignPropertiesSuccess, countForeignPropertiesFail);};

var handleLoad = function handleLoad(state, action) {return (0, _reduxLoop.loop)(Object.assign({},
  state, {
    loading: true,
    loaded: false,
    query: action.params,
    skip: (0, _get2.default)(action, 'params.$skip', 0) }),
  promise(fetchLoad, action));};

var handleCount = function handleCount(state, action) {return (0, _reduxLoop.loop)(Object.assign({},
  state),
  promise(fetchCount, action));};

var handleLoadSuccess = function handleLoadSuccess(state, action) {
  var data = (0, _get2.default)(action, 'data.data');
  var meta = (0, _get2.default)(action, 'data.meta', {});

  return Object.assign({},
  state, {
    loading: false,
    loaded: true,
    data: state.skip ? [].concat(state.data, data) : data,
    meta: meta });

};

var handleLoadFail = function handleLoadFail(state, response) {
  var error = (0, _formatApiError2.default)(response, 'Error while loading home page properties');

  return Object.assign({},
  state, {
    loading: false,
    loaded: false,
    data: [],
    error: error });

};

var handleCountSuccess = function handleCountSuccess(state, action) {
  var count = (0, _get2.default)(action, 'data');
  return Object.assign({},
  state, {
    count: count });

};

var handleCountFail = function handleCountFail(state, response) {
  var error = (0, _formatApiError2.default)(response, 'Error while loading home page properties');

  return Object.assign({},
  state, {
    count: 0,
    error: error });

};

var handleSaveSearchedForeignAddress = function handleSaveSearchedForeignAddress(state, action) {return Object.assign({},
  state, {
    searchedAddress: action });};


var handleClearForeignSearchData = function handleClearForeignSearchData() {return Object.assign({},
  initialState);};


var handleClearAddress = function handleClearAddress(state) {return Object.assign({},
  state, {
    searchedAddress: null,
    query: {} });};


var foreignPropertySearch = (0, _reduxAct.createReducer)(function (on) {
  on(saveSearchedForeignAddress, handleSaveSearchedForeignAddress);
  on(searchForeignProperties, handleLoad);
  on(searchForeignPropertiesSuccess, handleLoadSuccess);
  on(searchForeignPropertiesFail, handleLoadFail);
  on(countForeignProperties, handleCount);
  on(countForeignPropertiesSuccess, handleCountSuccess);
  on(countForeignPropertiesFail, handleCountFail);
  on(clearForeignSearchData, handleClearForeignSearchData);
  on(clearAddress, handleClearAddress);
}, initialState);exports.


searchForeignProperties = searchForeignProperties;exports.
countForeignProperties = countForeignProperties;exports.
saveSearchedForeignAddress = saveSearchedForeignAddress;exports.
clearForeignSearchData = clearForeignSearchData;exports.
clearAddress = clearAddress;exports.default =


foreignPropertySearch;


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/foreignPropertySearch.js
// module id = 198
// module chunks = 0